/**
 * Safely formats an authentication token with Bearer prefix if needed
 * @param {string} token - The authentication token
 * @param {boolean} shouldAddBearer - Whether to add Bearer prefix for Apigee X
 * @returns {string} - The formatted token
 */
export const formatAuthToken = (token, shouldAddBearer = false) => {
  if (!token) {
    return token;
  }

  // If we don't need to add Bearer, return as is
  if (!shouldAddBearer) {
    return token;
  }

  // Check if token already starts with "Bearer " (case insensitive) with a space after
  // or if it's exactly "Bearer" (without space)
  const lowerToken = token.toLowerCase();
  if (lowerToken.startsWith('bearer ') || lowerToken === 'bearer') {
    return token;
  }

  // Add Bearer prefix
  return `Bearer ${token}`;
};
